import { createTheme } from '@material-ui/core/styles'
import grey from '@material-ui/core/colors/grey'
import blue from '@material-ui/core/colors/blue'

export default createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: `"Arial Regular", "Arial Medium", sans-serif`,
  },
  palette: {
    primary: blue,
    disabled: {
      main: grey[300],
      dark: '#A6A6A6',
    },
  },
})

export const ksTheme = {
  colors: {
    paper: '#F4F4F4',
    black: '#050519',
    gray: {
      100: '#D0D0D0',
      300: '#B8B8B8',
      500: '#A1A1A1',
      700: '#676767',
      900: '#454545',
      regular: '#898989',
    },
    nightshade: {
      light: '#5856FF',
      medium: '#4241BF',
      dark: '#2C2B80',
    },
    lilac: {
      dark: '#A2A2FF',
      medium: '#B5B5FF',
      light: '#C7C7FF',
    },
    kellyGreen: {
      dark: '#00A162',
      medium: '#33B481',
      light: '#66C7A1',
    },
    darkGreen: {
      light: '#00613B',
      medium: '#00492C',
      dark: '#00331E',
    },
    accentYellow: '#F8FF00',
    red: '#ffc9c2',
    semantic: {
      surface: '#FFFFFF',
      surfaceRaised: '#FAFAFB',
      surfaceMuted: '#F4F4F4',
      surfaceSunken: '#EFEFF3',
      border: '#E5E5EC',
      borderStrong: '#D0D0D0',
      textPrimary: '#050519',
      textMuted: '#676767',
      textFaint: '#898989',
      accent: '#4241BF',
      accentHover: '#2C2B80',
      accentLight: '#5856FF',
      lilacLight: '#C7C7FF',
      lilacTint: '#EEEEFF',
      success: '#00A162',
      successTint: '#E6F5EE',
      warn: '#D98E00',
      warnTint: '#FBF1DE',
      danger: '#D0342C',
      dangerTint: '#FBE7E5',
      shadowSm: '0 1px 2px rgba(5,5,25,0.04)',
      shadowMd: '0 4px 14px rgba(5,5,25,0.06), 0 1px 2px rgba(5,5,25,0.04)',
      shadowLg: '0 20px 48px rgba(5,5,25,0.16), 0 4px 12px rgba(5,5,25,0.06)',
    },
  },
  fontFamily: {
    sans: ['FK Grotesk Semi-mono', 'sans-serif'],
  },
}
